/**
 * IMPORTS
 */
import {AckTypes} from 'src/aggregates/conversations/message/messages.d';
import {ITemplateInput} from 'src/aggregates/conversations/queries.d';
import {IMessage} from 'src/aggregates/conversations/state.d';
import {IMessageOnProgress} from 'src/aggregates/conversations/state.d';
import {IMessageOnSuccess} from 'src/aggregates/conversations/state.d';
import {IMetricsFilters} from 'src/aggregates/conversations/state.d';
import {IQualityMetadata} from 'src/aggregates/conversations/state.d';
import {_aggregates} from 'src/aggregates/index.d';
import {ICommand} from 'src/aggregates/index.d';
import {IFeedbackParams} from 'src/aggregates/utils/feedback';
import {ToastTypes} from 'src/aggregates/utils/feedback';
import {IMessage as IComponentMessage}
    from 'src/components/Shared/Message/index.d';


/**
 * EXPORTS
 */

/**
 * Commands names.
 */
export enum _names
{
    CONVERSATION_ADD_FORWARDING_MESSAGE = 'CONVERSATION_ADD_FORWARDING_MESSAGE',
    CONVERSATION_ANALYZE_QUALITY = 'CONVERSATION_ANALYZE_QUALITY',
    CONVERSATION_CLOSE_SESSION = 'CONVERSATION_CLOSE_SESSION',
    CONVERSATION_ENSURE = 'CONVERSATION_ENSURE',
    CONVERSATION_ENSURE_ONGOING = 'CONVERSATION_ENSURE_ONGOING',
    CONVERSATION_EXPIRE_QUALITY_ANALYSES =
        'CONVERSATION_EXPIRE_QUALITY_ANALYSES',
    CONVERSATION_FETCH = 'CONVERSATION_FETCH',
    CONVERSATION_FETCH_AGENTS_MESSAGES_METRICS =
        'CONVERSATION_FETCH_AGENTS_MESSAGES_METRICS',
    CONVERSATION_FETCH_BY_IDS =
        'CONVERSATION_FETCH_BY_IDS',
    CONVERSATION_FETCH_MESSAGE_BY_ORIGINAL_ID =
        'CONVERSATION_FETCH_MESSAGE_BY_ORIGINAL_ID',
    CONVERSATION_FETCH_METRICS = 'CONVERSATION_FETCH_METRICS',
    CONVERSATION_FETCH_QUALITY_REPORT = 'CONVERSATION_FETCH_QUALITY_REPORT',
    CONVERSATION_FINISH = 'CONVERSATION_FINISH',
    CONVERSATION_FOCUS = 'CONVERSATION_FOCUS',
    CONVERSATION_FORCE_FINISH_BY_ADMIN = 'CONVERSATION_FORCE_FINISH_BY_ADMIN',
    CONVERSATION_LISTEN = 'CONVERSATION_LISTEN',
    CONVERSATION_LOAD_ONGOING_BY_CUSTOMER =
        'CONVERSATION_LOAD_ONGOING_BY_CUSTOMER',
    CONVERSATION_PRIORITIZE_ORDER = 'CONVERSATION_PRIORITIZE_ORDER',
    CONVERSATION_ON_CREATE = 'CONVERSATION_ON_CREATE',
    CONVERSATION_ON_ECHO_CREATE = 'CONVERSATION_ON_ECHO_CREATE',
    CONVERSATION_ON_ECHO_MESSAGE = 'CONVERSATION_ON_ECHO_MESSAGE',
    CONVERSATION_ON_EXIT = 'CONVERSATION_ON_EXIT',
    CONVERSATION_ON_FEEDBACK = 'CONVERSATION_ON_FEEDBACK',
    CONVERSATION_ON_HEARTBEAT_CONFLICT = 'CONVERSATION_ON_HEARTBEAT_CONFLICT',
    CONVERSATION_ON_HEARTBEAT_FAILURE = 'CONVERSATION_ON_HEARTBEAT_FAILURE',
    CONVERSATION_ON_HEARTBEAT_SUCCESS = 'CONVERSATION_ON_HEARTBEAT_SUCCESS',
    CONVERSATION_ON_MESSAGE = 'CONVERSATION_ON_MESSAGE',
    CONVERSATION_ON_MESSAGE_ACK = 'CONVERSATION_ON_MESSAGE_ACK',
    CONVERSATION_ON_QUALITY_ANALYZED = 'CONVERSATION_ON_QUALITY_ANALYZED',
    CONVERSATION_ON_TYPE_TEXT = 'CONVERSATION_ON_TYPE_TEXT',
    CONVERSATION_ON_UPLOAD_PROGRESS = 'CONVERSATION_ON_UPLOAD_PROGRESS',
    CONVERSATION_ON_UPLOAD_SUCCESS = 'CONVERSATION_ON_UPLOAD_SUCCESS',
    CONVERSATION_OPEN_SESSION = 'CONVERSATION_OPEN_SESSION',
    CONVERSATION_REMOVE = 'CONVERSATION_REMOVE',
    CONVERSATION_REMOVE_FEEDBACK = 'CONVERSATION_FEEDBACK_REMOVE',
    CONVERSATION_RESET_ERROR = 'CONVERSATION_RESET_ERROR',
    CONVERSATION_RESET_TRANSFER = 'CONVERSATION_RESET_TRANSFER',
    CONVERSATION_LOAD = 'CONVERSATION_LOAD',
    CONVERSATION_LOAD_BY_CUSTOMER = 'CONVERSATION_LOAD_BY_CUSTOMER',
    CONVERSATION_LOAD_BY_PERIOD = 'CONVERSATION_LOAD_BY_PERIOD',
    CONVERSATION_LOAD_ONLINE_AGENTS = 'CONVERSATION_LOAD_ONLINE_AGENTS',
    CONVERSATION_LOAD_PAGE = 'CONVERSATION_LOAD_PAGE',
    CONVERSATION_CREATE = 'CONVERSATION_CREATE',
    CONVERSATION_FETCH_REALTIME_METRICS =
        'CONVERSATION_FETCH_REALTIME_METRICS',
    CONVERSATION_REMOVE_FORWARDING_MESSAGE =
        'CONVERSATION_REMOVE_FORWARDING_MESSAGE',
    CONVERSATION_RETRY_MESSAGE = 'CONVERSATION_RETRY_MESSAGE',
    CONVERSATION_SEND_EMAIL = 'CONVERSATION_SEND_EMAIL',
    CONVERSATION_SEND_MESSAGE = 'CONVERSATION_SEND_MESSAGE',
    CONVERSATION_SEND_TEMPLATE = 'CONVERSATION_SEND_TEMPLATE',
    CONVERSATION_SET_METRICS_PERIOD = 'CONVERSATION_SET_METRICS_PERIOD',
    CONVERSATION_SET_QUALITY_METADATA = 'CONVERSATION_SET_QUALITY_METADATA',
    CONVERSATION_START = 'CONVERSATION_START',
    CONVERSATION_START_FORWARD = 'CONVERSATION_START_FORWARD',
    CONVERSATION_STOP = 'CONVERSATION_STOP',
    CONVERSATION_STOP_FORWARD = 'CONVERSATION_STOP_FORWARD',
    CONVERSATION_STOP_QUALITY_REPORT = 'CONVERSATION_STOP_QUALITY_REPORT',
    CONVERSATION_TRANSFER = 'CONVERSATION_TRANSFER',
}


/**
 * Commands interfaces.
 */
export interface IConversationAddForwardingMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ADD_FORWARDING_MESSAGE;
    message: IComponentMessage;
}

export interface IConversationCloseSession extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_CLOSE_SESSION;
}

export interface IConversationEnsure extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ENSURE;
}

export interface IConversationEnsureOngoing extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ENSURE_ONGOING;
}

export interface IConversationFetch extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH;
}

export interface IConversationFetchAgentsMessagesMetrics extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_AGENTS_MESSAGES_METRICS;
    filters?: IMetricsFilters;
}

export interface IConversationFetchByIds extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_BY_IDS;
    conversations: number[];
}

export interface IConversationFetchMessageByOriginalId extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_MESSAGE_BY_ORIGINAL_ID;
    message: number
    reply: string;
}

export interface IConversationFetchMetrics extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_METRICS;
    force: boolean;
}

export interface IConversationFetchQualityReport extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_QUALITY_REPORT;
}

export interface IConversationFinish extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FINISH;
    conversations: number[];
}

export interface IConversationFocus extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FOCUS;
    account: number | null;
    contact: string | number | null;
    conversation: string | number | null;
}

export interface IConversationForceFinish extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FORCE_FINISH_BY_ADMIN;
}

export interface IConversationListen extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LISTEN;
}

export interface IConversationLoadOngoingByCustomer extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD_ONGOING_BY_CUSTOMER;
    customer: string | number;
}

export interface IConversationPrioritizeOrder extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_PRIORITIZE_ORDER;
    addHistoryBottom: (number | string)[];
    addHistoryTop: (number | string)[];
    addOngoingBottom: (number | string)[];
    addOngoingTop: (number | string)[];
    remove: (number | string)[];
}

export interface IConversationOnCreate extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_CREATE;
    account: number;
    channel: string;
    contactId: number;
    contactUid: string;
    hasAgentAnswer: boolean | null;
    lastInteraction: number;
    name: string;
    start: number;
    subject: string | null;
    templateRequired: boolean;
    templateSent: number | null;
    unansweredMessages: number;
}

export interface IConversationOnEchoCreate extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_ECHO_CREATE;
    account: number;
    channel: string;
    contactId: number;
    contactUid: string;
    hasAgentAnswer: boolean | null;
    lastInteraction: number;
    name: string;
    start: number;
    subject: string | null;
    templateRequired: boolean;
    templateSent: number | null;
    unansweredMessages: number;
}

export interface IConversationOnExit extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_EXIT;
    status: number;
    end: number | null;
    lastInteraction: number;
    uid: string;
}

export interface IConversationLoad extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD;
    agent: string;
}

export interface IConversationLoadByCustomer extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD_BY_CUSTOMER;
    customer: number | string;
}

export interface IConversationLoadByPeriod extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD_BY_PERIOD;
    agent: string;
    from: number;
    to: number;
}

export interface IConversationLoadOnlineAgents extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD_ONLINE_AGENTS;
    company: number;
}

export interface IConversationLoadPage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_LOAD_PAGE;
}

export interface IConversationOnEchoMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_ECHO_MESSAGE;
    ack: string;
    body: string;
    caption: string;
    id: number;
    messageClass: string;
    messageType: number;
    mode: number | null;
    name: string;
    originalId: string;
    outgoing: string | null;
    referral: string | null;
    reply: string | null;
    timestamp: number;
    uid: string;
    unansweredMessages: number | null;
}

export interface IConversationOnFeedback extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_FEEDBACK;
    closable: boolean;
    code: string;
    duration: number;
    params: IFeedbackParams;
    title: string;
    type: ToastTypes;
}

export interface IConversationOnHeartbeatConflict extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_HEARTBEAT_CONFLICT;
}

export interface IConversationOnHeartbeatSuccess extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_HEARTBEAT_SUCCESS;
    conversationsOnQueue: number;
}

export interface IConversationOnHeartbeatFailure extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_HEARTBEAT_FAILURE;
}

export interface IConversationOnMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_MESSAGE;
    ack: string;
    body: string;
    caption: string;
    id: number;
    messageClass: string;
    messageType: number;
    mode: number | null;
    name: string;
    originalId: string;
    referral: string | null;
    reply: string | null;
    timestamp: number;
    uid: string;
    unansweredMessages: number | null;
}

export interface IConversationOnMessageAck extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_MESSAGE_ACK;
    ack: AckTypes;
    id: number;
    originalId: string;
}

export interface IConversationOnTypeText extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_TYPE_TEXT;
    text: string;
}

export interface IConversationOnUploadProgress extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_UPLOAD_PROGRESS;
    id: number;
    originalId: string;
    percentage: number;
}

export interface IConversationOnUploadSuccess extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_UPLOAD_SUCCESS;
    id: number;
    originalId: string;
}

export interface IConversationOpenSession extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_OPEN_SESSION;
}

export interface IConversationFetchRealTimeMetrics extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_FETCH_REALTIME_METRICS;
}

export interface IConversationRemove extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_REMOVE;
}

export interface IConversationRemoveFeedback extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_REMOVE_FEEDBACK;
    index: number;
}

export interface IConversationResetError extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_RESET_ERROR;
}

export interface IConversationResetTransfer extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_RESET_TRANSFER;
}

export interface IConversationCreate extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_CREATE;
    account: number;
    contact: string;
    subject: string | null;
    type: number;
}

export interface IConversationRemoveForwardingMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_REMOVE_FORWARDING_MESSAGE;
    message: number;
}

export interface IConversationRetryMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_RETRY_MESSAGE;
    message: IMessage;
    onProgress: IMessageOnProgress;
    onSuccess: IMessageOnSuccess;
}

export interface IConversationSendEmail extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_SEND_EMAIL;
    account: number;
    attachments: File[];
    body: string;
    contact: string;
    onProgress: IMessageOnProgress;
    onSuccess: IMessageOnSuccess;
    sender: string;
    subject: string;
}

export interface IConversationSendMessage extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_SEND_MESSAGE;
    contact: string;
    message: IMessage;
    onProgress: IMessageOnProgress;
    onSuccess: IMessageOnSuccess;
    uploaded?: boolean;
}

export interface IConversationSendTemplate extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_SEND_TEMPLATE;
    templateInput: ITemplateInput,
}

export interface IConversationSetMetricsPeriod extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_SET_METRICS_PERIOD;
    endDate: number;
    filters: IMetricsFilters;
    startDate: number;
}

export interface IConversationSetQualityMetadata extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_SET_QUALITY_METADATA;
    metadata: IQualityMetadata;
}

export interface IConversationAnalyzeQuality extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ANALYZE_QUALITY;
}

export interface IConversationExpireQualityAnalyses extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_EXPIRE_QUALITY_ANALYSES;
    conversations: number[];
}

export interface IConversationOnQualityAnalyzed extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_ON_QUALITY_ANALYZED;
    analyzedAt: number;
    conversation: number;
    failed: boolean;
    score: number | null;
}

export interface IConversationStopQualityReport extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_STOP_QUALITY_REPORT;
}

export interface IConversationStart extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_START;
    isAdmin: boolean;
}

export interface IConversationStartForward extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_START_FORWARD;
}

export interface IConversationStop extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_STOP;
    isAdmin: boolean;
}

export interface IConversationStopForward extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_STOP_FORWARD;
}

export interface IConversationTransfer extends ICommand
{
    _aggregate: _aggregates.CONVERSATIONS;
    _name: _names.CONVERSATION_TRANSFER;
    to: string;
}
